import {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
} from '@/utils/aMap'
import { Taost } from 'vant'
import { movieCityListApi } from '@/api/movie'

/**
 * 根据城市名称通过电影城市接口获取并设置 city_id
 * 每当定位城市确定后调用，为电影模块提供正确的城市ID
 */
const fetchAndSetMovieCityId = async (state, cityName) => {
  if (!cityName) return
  try {
    const res = await movieCityListApi({
      keyword: cityName
    })
    const cityList = res.data?.data?.cityList
    if (Array.isArray(cityList) && cityList.length > 0) {
      // 优先精确匹配，其次包含匹配，最后取第一条
      const matched =
        cityList.find(c => {
          const name = c.name || c.city_name || ''
          return (
            name === cityName ||
            cityName.includes(name) ||
            name.includes(cityName)
          )
        }) || cityList[0]
      // city_id 供电影模块（影院列表、热映电影等）使用
      state.locationInfo.city_id =
        matched.id || matched.city_id || ''
    }
  } catch (err) {
    console.error('获取电影城市ID失败:', err)
  }
}

const setDeafultLocal = ({ commit, state }) => {
  state.locationInfo.lat = 23.12463
  state.locationInfo.lng = 113.36199
  state.locationInfo.city = '广州市'
  state.locationInfo.province = '广东省'
}

// 获取定位信息
const getLocation = ({ commit, state }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const AMapLocation = await location().catch(err => {
        console.error(err, '初始化定位失败')
        // 初始化失败时直接使用默认位置
        setDeafultLocal({ commit, state })
        // 异步获取默认城市的电影city_id，不阻塞resolve
        fetchAndSetMovieCityId(
          state,
          state.locationInfo.city
        )
        resolve({
          status: true,
          data: {},
          message: '使用默认位置'
        })
        return null
      })
      // 如果初始化失败，直接返回
      if (!AMapLocation) return
      await AMapLocation.getCurrentPosition(
        async (status, result) => {
          // 情况1：定位完全失败，尝试通过IP获取城市信息
          if (status !== 'complete') {
            console.warn('定位失败，尝试通过IP获取位置')
            AMapLocation.getCityInfo(
              async (cityStatus, cityResult) => {
                if (cityStatus === 'complete') {
                  state.locationInfo.lat =
                    cityResult.center?.[1] || ''
                  state.locationInfo.lng =
                    cityResult.center?.[0] || ''
                  state.locationInfo.city =
                    cityResult.city || '广州市'
                  state.locationInfo.province =
                    cityResult.province || '广东省'
                  // 城市确定后获取电影city_id
                  await fetchAndSetMovieCityId(
                    state,
                    state.locationInfo.city
                  )
                  resolve({
                    status: true,
                    data: { ...cityResult },
                    message: '通过IP获取位置信息成功'
                  })
                } else {
                  console.warn('IP定位也失败，使用默认位置')
                  setDeafultLocal({ commit, state })
                  // 异步获取默认城市的电影city_id
                  await fetchAndSetMovieCityId(
                    state,
                    state.locationInfo.city
                  )
                  resolve({
                    status: true,
                    data: {},
                    message: '定位失败，使用默认位置'
                  })
                }
              }
            )
            return
          }

          // 情况2：定位成功，检查是否有经纬度信息
          const hasLatLng =
            result.position &&
            (result.position.lat || result.position[1]) &&
            (result.position.lng || result.position[0])

          if (hasLatLng) {
            const lng =
              result.position.lng || result.position[0]
            const lat =
              result.position.lat || result.position[1]
            state.locationInfo.lng = lng
            state.locationInfo.lat = lat

            const locationType = result.location_type

            // 设置城市信息的公共方法
            const setCityInfo = (city, province) => {
              state.locationInfo.city =
                city || result.city || '广州市'
              state.locationInfo.province =
                province || result.province || '广东省'
            }

            // 城市确定后获取电影city_id，包装resolve供各路径复用
            const resolveSuccess = async (
              data,
              message
            ) => {
              await fetchAndSetMovieCityId(
                state,
                state.locationInfo.city
              )
              resolve({ status: true, data, message })
            }

            // 情况2-1：location_type 为 'ipcity'，直接使用 result.city
            if (locationType === 'ipcity') {
              setCityInfo()
              resolveSuccess(
                result,
                '通过IP定位获取城市信息成功'
              )
              return
            }

            // 情况2-2：location_type 为 'html5'，调用逆地理编码获取城市信息
            if (locationType === 'html5') {
              try {
                const AMapSearchCity = await SearchCity().catch(
                  err => {
                    console.error(err, '初始化获取城市失败')
                    return null
                  }
                )

                if (!AMapSearchCity) {
                  setCityInfo()
                  resolveSuccess(
                    result,
                    '获取定位成功，城市信息获取失败'
                  )
                  return
                }

                AMapSearchCity.getAddress(
                  [lng, lat],
                  (addressStatus, addressResult) => {
                    if (
                      addressStatus === 'complete' &&
                      addressResult.info === 'OK'
                    ) {
                      const {
                        city,
                        province
                      } = addressResult.regeocode.addressComponent
                      setCityInfo(city, province)
                      resolveSuccess(
                        { ...addressResult },
                        'HTML5定位获取城市信息成功'
                      )
                    } else {
                      setCityInfo()
                      resolveSuccess(
                        result,
                        '获取定位成功，地址解析失败'
                      )
                    }
                  }
                )
              } catch (err) {
                console.error('获取城市信息失败:', err)
                setCityInfo()
                resolveSuccess(
                  result,
                  '获取定位成功，处理过程中出现异常'
                )
              }
              return
            }

            // 其他 location_type 情况
            setCityInfo()
            resolveSuccess(result, '获取定位成功')
          } else if (result.province) {
            // 情况3：无经纬度但有基础城市信息（province字段存在）
            state.locationInfo.city =
              result.city || '广州市'
            state.locationInfo.province = result.province
            // 如果有position数组，尝试获取经纬度
            if (
              result.position &&
              result.position.length >= 2
            ) {
              state.locationInfo.lng =
                result.position[0] || ''
              state.locationInfo.lat =
                result.position[1] || ''
            }
            // 城市确定后获取电影city_id
            await fetchAndSetMovieCityId(
              state,
              state.locationInfo.city
            )
            resolve({
              status: true,
              data: result,
              message: '获取基础定位信息成功'
            })
          } else {
            // 其他情况：使用默认位置
            console.warn('定位信息不完整，使用默认位置')
            setDeafultLocal({ commit, state })
            // 城市确定后获取电影city_id
            await fetchAndSetMovieCityId(
              state,
              state.locationInfo.city
            )
            resolve({
              status: true,
              data: {},
              message: '定位信息不完整，使用默认位置'
            })
          }
        }
      )
    } catch (err) {
      console.error('定位服务异常:', err)
      setDeafultLocal({ commit, state })
      // 异步获取默认城市的电影city_id，不阻塞resolve
      fetchAndSetMovieCityId(state, state.locationInfo.city)
      resolve({
        status: true,
        data: {},
        message: '定位服务异常，使用默认位置'
      })
    }
  })
}

const setCity = ({ commit, state }, cityName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const AMapSearchCity = await SearchCity()

      await AMapSearchCity.getLocation(
        cityName,
        async function(status, result) {
          console.log('SearchCity结果:', status, result)
          if (
            status === 'complete' &&
            result.geocodes.length
          ) {
            const {
              location,
              addressComponent
            } = result.geocodes[0]

            state.locationInfo.lng = location.lng
            state.locationInfo.lat = location.lat
            state.locationInfo.city = addressComponent.city
            state.locationInfo.province =
              addressComponent.province

            // 城市确定后获取电影city_id
            await fetchAndSetMovieCityId(
              state,
              state.locationInfo.city
            )

            resolve({
              status: true,
              data: result,
              message: '定设置城市成功'
            })
          } else {
            // Taost('设置城市失败')
            resolve({
              status: false,
              message: '设置城市失败'
            })
          }
        }
      )
    } catch (err) {
      console.error('SearchCity失败', err)
    }
  })
  // AMapSearchCity.CitySearchCallback(
  //   ({ ip: '北京' }, result) => {
  //   }
  // )
}

// 设置电影定位信息 (mutation) - 已废弃，电影城市ID现由 fetchAndSetMovieCityId 自动写入 locationInfo.city_id
// const setMoiveInfo = (state, locationInfo) => {
//   state.moiveLocationInfo = locationInfo
// }

const state = {
  // moiveLocationInfo 已废弃，电影城市信息统一由 locationInfo.city / locationInfo.city_id 提供
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: '',
    city_id: '' // 电影城市ID，由 fetchAndSetMovieCityId 在每次定位后自动填充
  }
}

const mutations = {}

const actions = {
  getLocation,
  setCity
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
